import { createBrowserClient } from '@magicschool/supabase/clients/browser';
import { createClient } from '@supabase/supabase-js';

export const clientSupabase = createBrowserClient({
  overrideFetch: async (input: string | URL | Request, init?: RequestInit) => {
    try {
      const response = await fetch(input, init);
      return response;
    } catch {
      throw new Error('Failed to fetch');
    }
  },
});

// Lazy accessor for the implicit-flow Supabase client used only during password
// reset. Defers instantiation until the first call so pages that never visit
// forgot-/change-password don't pay the cost of a second client on import.
let _passwordResetSupabase: ReturnType<typeof createClient> | undefined;
// Uses createClient directly because @supabase/ssr's createBrowserClient
// hardcodes flowType: 'pkce' and cannot be overridden. With implicit flow
// Supabase sends a hash-fragment link (#access_token=...&type=recovery) that
// works in any browser — no sessionStorage code_verifier required.
export const getPasswordResetSupabase = () => {
  if (!_passwordResetSupabase) {
    _passwordResetSupabase = createClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL ?? 'http://localhost:54321',
      process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ?? '',
      {
        auth: {
          flowType: 'implicit',
          detectSessionInUrl: false,
          persistSession: false,
          autoRefreshToken: false,
        },
      },
    );
  }
  return _passwordResetSupabase;
};
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const untypedClientSupabase = clientSupabase as ReturnType<typeof createBrowserClient<any>>;
